import { useContext, useMemo } from 'react'
import { Footer, Header, Main, Paragraph } from '@tamman/ui-core'
import { BOALogo } from '@tamman/ui-logo'
import { OneTrustButton, OneTrustProvider } from '@tamman/ui-onetrust'
import { Box } from '@tamman/ui-layout'
import { TabCatcher } from '@tamman/ui-utils'

import { MOUNT_OPTIONS } from '../constants.mjs'
import MountContext from '../cra-custom-mounts/MountContext'
import AlternateLanguagePageLink from '../components/AlternateLanguagePageLink'

import EnglishPage from './EnglishPage'
import SpanishPage from './SpanishPage'

const ContentPage = () => {
  const mount = useContext(MountContext)

  const {
    isEnglishPage,
    isSpanishPage
  } = useMemo(() => {
    return {
      isEnglishPage: mount.options.language === MOUNT_OPTIONS.LANGUAGE.ENGLISH,
      isSpanishPage: mount.options.language === MOUNT_OPTIONS.LANGUAGE.SPANISH
    }
  }, [mount])

  const ContentPage = useMemo(() => {
    if (isEnglishPage) return EnglishPage
    if (isSpanishPage) return SpanishPage
  }, [isEnglishPage, isSpanishPage])

  const BoALogoComponent = (
    <BOALogo
      id='bank-logo-footer'
      target='_blank'
      rel='noopener noreferrer'
      href='https://www.bankofamerica.com/'
    />
  )

  return(
    <div className='page-wrapper'>
      <TabCatcher>
        <OneTrustProvider>
          <Header p='lg'>
            <Box className='heading-logo-link-container'>
              {BoALogoComponent}
              <AlternateLanguagePageLink {...mount.options.alternate_language_page.link} />
            </Box>
          </Header>
 
          <Main className='site-main' px='lg' pt='lg'>
            <Box className='container'>
              <ContentPage />
            </Box>
          </Main>

          <Footer px='lg' pb='lg'>
            {isSpanishPage &&
              <Paragraph className='spanish-note section'>
                Es posible que los materiales relacionados con la cuenta solo estén disponibles en inglés, lo que incluye, entre otros, solicitudes, divulgaciones, contenido en línea y móvil y otras comunicaciones relacionadas con el producto.
              </Paragraph>
            }
            {BoALogoComponent}
            <Box className='onetrust-container'>
              <OneTrustButton className='box__mt--lg link' />
            </Box>
            <Paragraph className='map-number'>{mount.footer.legalId}</Paragraph>
          </Footer>
        </OneTrustProvider>
      </TabCatcher>
    </div>
  )
}

export default ContentPage